export function getNumberWithoutComa(value?: string | number) {
  if (!value) {
    return 0;
  }

  return Number(value.toString().replace(/\D/g, ''));
}
